const src = import.meta.ROLLUP_FILE_URL_tgFyw$X211zXSctfMU9_LA;
export default {
  src,
  srcSet: src + " " + 1024 + "w",
  width: 1024,
  height: 1024,
};